import { useEffect, useRef } from 'react'
import { animate, useMotionValue, useTransform } from 'framer-motion'

export function AnimatedNumber({ value, suffix = '', prefix = '' }: { value: number; suffix?: string | undefined; prefix?: string | undefined }) {
  const ref = useRef<HTMLSpanElement>(null)
  const motionValue = useMotionValue(0)
  const rounded = useTransform(motionValue, (v) => Math.round(v).toLocaleString('en-US'))

  // No `useInView` gate here: the parent card (e.g. StatCard) already has
  // its own `whileInView` fade/slide-up reveal, so gating the count-up a
  // second time was redundant — and that second IntersectionObserver check
  // could miss its first callback on initial load, leaving the number
  // stuck on its "0" placeholder forever since nothing else would ever
  // trigger `animate()`. Animating on every `value` change (mount
  // included) is simpler and can't get stuck the same way.
  useEffect(() => {
    const controls = animate(motionValue, value, { duration: 1.1, ease: [0.22, 1, 0.36, 1] })
    return () => controls.stop()
  }, [value, motionValue])

  useEffect(() => {
    const unsub = rounded.on('change', (latest) => {
      if (ref.current) ref.current.textContent = `${prefix}${latest}${suffix}`
    })
    return unsub
  }, [rounded, prefix, suffix])

  return <span ref={ref}>{prefix}0{suffix}</span>
}
